import { Pipe, PipeTransform } from '@angular/core';

import { AlertSeverityStoreModelEnum } from '@domain/alerting/alerting.enums';

import { TranslateEnumPipeBase } from '../translate-enum-pipe-base';

const KEY_PREFIX = 'enums.alert-severity';
export const AlertSeverityKeyMapping = {
  [AlertSeverityStoreModelEnum.Info]: `${KEY_PREFIX}.info`,
  [AlertSeverityStoreModelEnum.Warning]: `${KEY_PREFIX}.warning`,
  [AlertSeverityStoreModelEnum.Critical]: `${KEY_PREFIX}.critical`,
};

@Pipe({
  name: 'translateAlertSeverity',
  pure: false,
  standalone: true,
})
export class TranslateAlertSeverityPipe extends TranslateEnumPipeBase<AlertSeverityStoreModelEnum> implements PipeTransform {
  protected readonly valueTranslateKeyMap = AlertSeverityKeyMapping;
}
